<template>
  <div>
    <v-card class="rounded-lg" elevation="0" color="#41916b">
      <v-card-title class="text-center justify-center" v-if="isEdit">
        <h5 class="font-weight-bold" style="color: white">
          {{ donorLabel }}
        </h5>
      </v-card-title>

      <v-tabs v-model="tab" fixed-tabs background-color="#41916b" dark>
        <v-tabs-slider color="#b1e3cc"></v-tabs-slider>
        <v-tab>{{ title }}</v-tab>

        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form @submit.prevent="saveBloodGroup" ref="bgForm" :disabled="disableForm">
                <div class="" style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 10px;
                    width: 100%;
                    margin-bottom: 5px;
                    margin-top: 3px;
                  " v-if="!isEdit">
                  <p style="font-weight: bold">Potencial Doador:</p>
                  <v-row>
                    <v-col class="d-flex" cols="12" sm="3">
                      <v-autocomplete :rules="formRules" :items="isEdit ? items : donor" color="#256936"
                        class="rounded-lg" v-model="bloodGroupForm.donor_id" item-value="id" item-text="name" dense
                        outlined label="Paciente/Potencial Doador" @change="changeCPF()">
                      </v-autocomplete>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="3">
                      <v-text-field color="#256936" :rules="formRules" class="rounded-lg" label="CPF" disabled outlined
                        v-model="cpf" maxlength="14" v-mask="'###.###.###-##'" dense></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div class="mb-2" style="
                    border: solid 1px #e1e3e2;
                    border-radius: 15px;
                    padding: 10px;
                    width: 100%;
                    position: relative;
                  " v-for="(bloodGroup, index) in bloodGroups" :key="index">
                  <p style="font-weight: bold">Grupo Sanguíneo:</p>
                  <v-row dense>
                    <v-col class="d-flex" cols="12" sm="3">
                      <v-text-field color="#256936" class="rounded-lg" :rules="formRules"
                        :disabled="isEdit && editingIndex !== index" outlined v-model="bloodGroup.report_number" dense>
                        <template v-slot:label>
                          Nº do Laudo/AAAA <span style="color: red">*</span>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="2">
                      <v-text-field color="#086318" class="rounded-lg" :rules="formRules"
                        :disabled="isEdit && editingIndex !== index" :max="maxDate"
                        @input="onlyDateInput('sample_date', $event)" type="date" outlined
                        v-model="bloodGroup.sample_date" dense>
                        <template v-slot:label>
                          Data da Coleta de Amostra
                          <span style="color: red">*</span>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="2">
                      <v-text-field color="#256936" class="rounded-lg" type="datetime-local"
                        @input="onDateTimeInput('release_date', $event)" :rules="formRules"
                        :disabled="isEdit && editingIndex !== index" :max="maxDateTime" outlined
                        v-model="bloodGroup.release_date" dense>
                        <template v-slot:label>
                          Data e Horário da Liberação
                          <span style="color: red">*</span>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="2">
                      <v-autocomplete :rules="formRules" :disabled="isEdit && editingIndex !== index"
                        :items="exames_types" color="#256936" class="rounded-lg" v-model="bloodGroup.type_report_id"
                        item-value="value" item-text="description" dense outlined>
                        <template v-slot:label>
                          Tipo de Exame <span style="color: red">*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="3">
                      <v-autocomplete :rules="formRules" :items="blood_factors" color="#256936"
                        :disabled="isEdit && editingIndex !== index" class="rounded-lg"
                        v-model="bloodGroup.blood_factor_id" item-value="id" item-text="description" dense outlined>
                        <template v-slot:label>
                          Fator Sanguíneo <span style="color: red">*</span>
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                  <p style="font-weight: bold">Responsável pelos Exames:</p>
                  <v-row>
                    <v-col class="d-flex" cols="12" sm="3">
                      <v-text-field color="#256936" class="rounded-lg" :disabled="isEdit && editingIndex !== index"
                        :rules="formRules" v-model="bloodGroup.responsible_name" outlined dense>
                        <template v-slot:label>
                          Nome do Responsável <span style="color: red">*</span>
                        </template>
                      </v-text-field>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="2">
                      <v-text-field color="#256936" class="rounded-lg" :disabled="isEdit && editingIndex !== index"
                        :rules="formRules" v-model="bloodGroup.advice" outlined dense>
                        <template v-slot:label>
                          Conselho <span style="color: red">*</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-btn small class="edit-btn rounded-lg" color="#41916b" @click="editBloodGroup(index)"
                    v-if="isEdit && editingIndex != index">
                    <span class="span_color">
                      <v-icon size="18" color="white">mdi-pencil</v-icon>
                      {{$t('buttons.edit')}}
                    </span>
                  </v-btn>
                  <v-btn small class="edit-btn rounded-lg" color="primary" @click="saveBloodGroup(index)"
                    v-if="editingIndex == index">
                    <span class="span_color">
                      <v-icon size="18" color="white">mdi-content-save</v-icon>
                      {{$t('buttons.save')}}
                    </span>
                  </v-btn>
                </div>
                <v-row class="buttons pa-3 d-flex justify-center align-center mt-2" v-if="disableForm == false">
                  <div class="d-flex">
                    <v-btn v-if="!isEdit" class="rounded-lg mr-1" elevation="0" type="submit" :disabled="disableButton"
                      color="#41916b" :loading="loading">
                      <span style="color: white">
                        {{ $route.query.item ? "Atualizar" : "Salvar" }}
                      </span>
                    </v-btn>

                    <v-btn v-if="!isEdit" class="rounded-lg mr-1" elevation="0" color="#96af9c" @click="clear()">
                      <span style="color: white">{{$t('buttons.clean_up')}}</span>
                    </v-btn>

                    <v-btn class="rounded-lg" elevation="0" color="grey" @click="$router.push('/grupo-sanguineo')">
                      <span style="color: white">{{$t('buttons.return')}}</span>
                    </v-btn>
                  </div>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapActions, mapGetters } from "vuex";
import { getFactors } from "@/service/SerologyService";
import dateTimeLimit from "@/utils/dateTimeLimit";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
export default {
  data() {
    return {
      tab: 1,
      disableButton: this.disableButton,
      bloodGroupForm: {},
      formRules: [(v) => !!v || "Este campo é obrigatório"],
      items: [],
      donor: [],
      blood_factors: [],
      cpf: "",
      disableForm: this.profile == "TÉC. HEMOBA SOROLOGIA" ? true : false,
      loading: false,
      exames_types: [
        { value: "1", description: "Córnea" },
        { value: "2", description: "Esclera" },
        { value: "3", description: "Múltiplos Orgãos" },
      ],
      bloodGroups: [
        {
          report_number: null,
          sample_date: null,
          responsible_name: null,
          advice: null,
          release_date: null,
          type_report_id: null,
          blood_factor_id: null,
        },
      ],
      editingIndex: null
    };
  },

  async created() {
    await this.loadGridData();
    await this.fillForm(this.getBloodGroupsPatientData);
  },

  computed: {
    ...mapGetters([
      "currentUser",
      "getBloodGroupsPatientData"
    ]),

    isEdit() {
      if (this.getBloodGroupsPatientData == null) return false
      return this.getBloodGroupsPatientData.id
    },

    title() {
      return this.isEdit ? 'Atualizar GRUPO SANGUÍNEO' : 'Novo GRUPO SANGUÍNEO'
    },

    donorLabel() {
      const { kind_of_donor, name } = this.getBloodGroupsPatientData;

      return `Paciente ${kind_of_donor.name} - ${name}`;
    },

    donorCPF() {
      const { cpf } = this.getBloodGroupsPatientData;

      return `CPF: ${cpf}`;
    },

    currentUser() {
      return currentUser.getUserData();
    },

    maxDateTime() {
      const now = new Date();
      return now.toISOString().slice(0, 16);
    },

    maxDate() {
      const now = new Date();
      return now.toISOString().slice(0, 10);
    },

    profile() {
      const profile = this.currentUser.profile;
      return profileSlug(profile);
    },
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeDonorId", "changeBloodGroupsPatientData"]),

    addBloodGroup() {
      this.bloodGroups.push({
        report_number: null,
        sample_date: null,
        responsible_name: null,
        advice: null,
        release_date: null,
        type_report_id: null,
        blood_factor_id: null,
      });
    },
    removeBloodGroup() {
      this.bloodGroups.pop();
    },

    onlyDateInput(path, field, value) {
      this[path][field] = dateTimeLimit.limiteInputOnlyDate(value);
    },
    onDateTimeInput(field, value) {
      this.bloodGroupForm[field] = dateTimeLimit.limitYearField(value);
    },

    async loadGridData() {
      const bloodGroups = await getFactors();
      this.blood_factors = bloodGroups;
    },

    changeCPF() {
      const arrayDonors = this.getBloodGroupsPatientData ? this.items : this.donor;
      if (this.getBloodGroupsPatientData) {
        (this.cpf = arrayDonors.find(
          (donor) => donor.user_id == this.bloodGroupForm.donor_id,
        )),
          (this.cpf = this.cpf.cpf);
      } else {
        (this.cpf = arrayDonors.find(
          (donor) => donor.id == this.bloodGroupForm.donor_id,
        )),
          (this.cpf = this.cpf.cpf);
      }
    },

    editBloodGroup(position) {
      this.editingIndex = position;
    },

    saveBloodGroup(index = 0) {
      if (this.$refs.bgForm.validate()) {
        this.loading = true;

        const bg = this.bloodGroups[index];

        let donor_id = this.bloodGroupForm.donor_id
          ? this.bloodGroupForm.donor_id
          : this.getBloodGroupsPatientData.id;

        let data = {
          user_id: this.currentUser.id,
          donor_id: donor_id,
          type_report_id: bg.type_report_id,
          report_number: bg.report_number,
          sample_date: bg.sample_date,
          release_date: this.formatDateTimeToBackend(bg.release_date),
          responsible_name: bg.responsible_name,
          advice: bg.advice,
          blood_factor_id: bg.blood_factor_id,
        };

        axios({
          method: bg.id ? "PUT" : "POST",
          url: bg.id
            ? `/blood_groups/${bg.id}`
            : `blood_groups/create`,
          data: data,
        })
          .then((response) => {
            this.changeSnackBarData({
              status: true,
              type: "success",
              titleMessage: response.data.message,
              bodyMessage: "",
              cardColor: "#41916b",
              titleIcon: "mdi-checkbox-marked-circle",
            });

            setTimeout(() => {
              this.loading = false;
              this.closeSnackBar();

              this.editingIndex = null;

              this.$emit("changeTab", 1);
              this.$emit("donorId", donor_id);
              this.changeDonorId(donor_id);
              this.$emit("bloodGroupId", response.data.id.id);
            }, 3000);
          })
          .catch((err) => {
            this.loading = false;

            this.changeSnackBarData({
              status: true,
              type: "erro",
              titleMessage: err.error,
              bodyMessage: err.details,
              cardColor: "red",
              titleIcon: "mdi-close-circle",
            });

            setTimeout(() => this.closeSnackBar(), 5000);
          });
      }
    },

    async fillForm(item) {
      if (this.isEdit) {
        this.bloodGroups = item.blood_groups.map(bloodGroup => ({
          ...bloodGroup,
          blood_factor_id: Number(bloodGroup.blood_factor.id),
          sample_date: this.formatDateForInput(bloodGroup.sample_date),
          release_date: bloodGroup.release_date?.replace(' ', 'T')
        }))
      }
    },

    formatDateForInput(dateTime) {
      return dateTime.split(" ")[0];
    },

    formatDateTimeToBackend(value) {
      if (!value) return null;
      return value.replace("T", " ").slice(0, 16);
    },

    closeSnackBar() {
      this.changeSnackBarData({
        status: false,
        type: "",
        titleMessage: "",
        bodyMessage: "",
        cardColor: "",
        titleIcon: "",
      });
    },
  },
};
</script>
<style scoped>
.edit-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.span_color {
  color: #FFFFFF;
}
</style>
